<template>
  <div>
    <MyPlayer v-if="show" autoplay :list="list" class="player" />
  </div>
</template>

<script>
import MyPlayer from '@/components/MyPlayer'
import { punchCardVideo } from '@/api/punchCardVideo'
export default {
  components: {
    MyPlayer
  },
  data() {
    return {
      list: [],
      classroomId: this.$route.query.classroomId,
      campusId: this.$route.query.campusId,
      startTime: this.$route.query.startTime,
      show: false
    }
  },
  created() {
    punchCardVideo({
      classroomId: this.classroomId ? this.classroomId : '',
      campusId: this.campusId ? this.campusId : '',
      startTime: this.startTime ? this.startTime : ''
    }).then(res => {
      res.data.array.map(v => {
        this.list.push(v.video)
      })
      this.show = true
    })
  },
  mounted() {},
  methods: {}
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.player{
  height: 600px;
  width: 600px;
}

</style>
